var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E72D18",
    strokeWidth: 2,
    d: "M12 2.088L1.685 21h20.63L12 2.088z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "#E72D18",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E72D18",
    fillRule: "nonzero",
    d: "M12 8c.513 0 .936.42.993.961l.007.127v4.824c0 .6-.448 1.088-1 1.088-.513 0-.936-.42-.993-.961L11 13.912V9.088c0-.6.448-1.088 1-1.088z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "assets/images/error.91f1bc903db83fe79155a41bfc127853.svg";
export { ForwardRef as ReactComponent };